export function formatted(date) {
  return new Date(date).toString().slice(0, 15);
}

// Format date to YYYY/MM/DD
export function formatDateToDigits(newdate) {
  const date = new Date(newdate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}

// Format date to YYYY-MM-DD
export function formatDateToDashDigits(newdate) {
  const date = new Date(newdate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function formatDateStrings(dateString) {
  const dateParts = dateString.split("-");
  const year = parseInt(dateParts[0]);
  const month = parseInt(dateParts[1]) - 1;
  const day = parseInt(dateParts[2]);

  return new Date(year, month, day);
}

// Calculate the next date with by given number
export function calculatePreferredDueDate(currentDay, numberofdays) {
  // Get the current date
  const currentDate = currentDay;

  // Calculate the new date by adding provided days
  const numberOfDaysToAdd = numberofdays;
  const newDate = new Date(currentDate);
  newDate.setDate(newDate.getDate() + numberOfDaysToAdd);

  const formattedNewDate = newDate.toISOString().split("T")[0];
  return formattedNewDate;
}

// To format date and time to ago
export function timeAgo(timestamp) {
  const now = new Date();
  const targetDate = new Date(timestamp);

  const elapsedMillis = now - targetDate;
  const elapsedSeconds = Math.floor(elapsedMillis / 1000);

  if (elapsedSeconds < 60) {
    return `${elapsedSeconds} seconds ago`;
  } else if (elapsedSeconds < 3600) {
    const minutes = Math.floor(elapsedSeconds / 60);
    if (minutes === 1) {
      return `${minutes} minute ago`;
    } else {
      return `${minutes} minutes ago`;
    }
  } else if (elapsedSeconds < 86400) {
    const hours = Math.floor(elapsedSeconds / 3600);
    if (hours === 1) {
      return `${hours} hour ago`;
    } else {
      return `${hours} hours ago`;
    }
  } else {
    const days = Math.floor(elapsedSeconds / 86400);
    if (days === 1) {
      return `${days} day ago`;
    } else {
      return `${days} days ago`;
    }
  }
}

export function formatToMonthandYear(timestamp) {
  const date = new Date(timestamp);

  const options = { year: "numeric", month: "short" };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  return formattedDate;
}

export function formattedTime(timestamp) {
  const datetimeString = timestamp;
  const datetime = new Date(datetimeString);

  let hours = datetime.getUTCHours();
  let minutes = datetime.getUTCMinutes();

  let amOrPm = "AM"; // Default to "AM"

  if (hours >= 12) {
    amOrPm = "PM";
    if (hours > 12) {
      hours -= 12; // Convert to 12-hour format if it's PM and not noon (12 PM)
    }
  }

  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")} ${amOrPm}`;
  return formattedTime;
}

export function formatDateWIthTime(originalDate) {
  const date = new Date(originalDate);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const year = date.getUTCFullYear();
  const month = months[date.getUTCMonth()];
  const day = date.getUTCDate();
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? "pm" : "am";

  // Convert hours to 12-hour format
  if (hours > 12) {
    hours -= 12;
  } else if (hours === 0) {
    hours = 12;
  }

  const formattedDate = `${month} ${day}, ${year} - ${hours}:${
    minutes < 10 ? "0" : ""
  }${minutes} ${ampm}`;

  return formattedDate;
}
